import { createElement } from 'react'

import logo from './logo.svg'

export function Logo({ className }: { className: string }) {
  return createElement('img', { 'data-test': 'logo', className, src: logo })
}

export default Logo
